// extracted by mini-css-extract-plugin
module.exports = {"formRow":"form_formRow__wf9LT","formRowLegend":"form_formRowLegend__nimTS","inputColumn":"form_inputColumn___rtqr","inputsRow":"form_inputsRow__PzQU6"};